

export class PoiAlertSpecificationOutput implements IPoiAlertSpecificationOutput {
    /** The auto-generated id of the poi master */
    poi_details_id!: number;

    constructor(data?: IPoiAlertSpecificationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_details_id = _data["poi_details_id"];
        }
    }

    static fromJS(data: any): PoiAlertSpecificationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiAlertSpecificationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_details_id"] = this.poi_details_id;
        return data; 
    }
}

export interface IPoiAlertSpecificationOutput {
    /** The auto-generated id of the poi master */
    poi_details_id: number;
}

